import { render } from "./FlagIconList.vue?vue&type=template&id=185c9cb4"
import script from "./FlagIconList.vue?vue&type=script&lang=js"
export * from "./FlagIconList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__